import { AvailableChildrenType, SugarElementInfo } from "../SugarElementInfo";

export const force: SugarElementInfo = { name: "force", availableChildren: { type: AvailableChildrenType.Any } };
export const ferm_vb_j: SugarElementInfo = {
    name: "ferm_vb_j",
    availableChildren: { type: AvailableChildrenType.Any },
};
export const address: SugarElementInfo = { name: "address", availableChildren: { type: AvailableChildrenType.Any } };
export const corrnumber: SugarElementInfo = {
    name: "corrnumber",
    availableChildren: { type: AvailableChildrenType.Any },
};
export const cross: SugarElementInfo = { name: "cross", availableChildren: { type: AvailableChildrenType.Any } };
export const ifns: SugarElementInfo = { name: "ifns", availableChildren: { type: AvailableChildrenType.Any } };
export const reorganization: SugarElementInfo = {
    name: "reorganization",
    availableChildren: { type: AvailableChildrenType.Any },
};
export const signer: SugarElementInfo = { name: "signer", availableChildren: { type: AvailableChildrenType.Any } };
